import React, { FC, ReactElement } from 'react'

import clsx from 'clsx'

import CloseIcon from '@mui/icons-material/Close'
import KeyboardBackspaceIcon from '@mui/icons-material/KeyboardBackspace'
import { Typography } from '@mui/material'
import IconButton from '@mui/material/IconButton'
import withStyles, { ClassNameMap } from '@mui/styles/withStyles'

import { finishErrorAlert } from 'redux/alert/alert-actions'
import { useAppDispatch, useAppSelector } from 'redux/hooks'
import { themeStyles } from 'themes'

interface IProps {
    classes: ClassNameMap
    title: string | ReactElement
    titleID: string
    closeID: string
    handleClose: () => void
    handleBack: () => void
    backEnabled: boolean
    backID: string
    closeDisable: boolean
    titleDisable: boolean
    longerTextEnabled?: boolean
}

const FixedModalHeader: FC<Partial<IProps>> = props => {
    const {
        classes,
        longerTextEnabled,
        title,
        titleID,
        closeID,
        handleClose,
        handleBack,
        backEnabled,
        backID,
        closeDisable = false,
        titleDisable = false,
    } = props
    const dispatch = useAppDispatch()
    const { errorAlert } = useAppSelector(state => state.alert)

    const handleBackButton = () => {
        !!errorAlert && dispatch(finishErrorAlert())
        handleBack()
    }

    return (
        <div className={clsx(!!longerTextEnabled && classes.modalFixedHeaderNowrap, classes.modalFixedHeader)}>
            {!!backEnabled && (
                <IconButton
                    data-sta-id={backID}
                    aria-label="back"
                    className={classes.modalBackButton}
                    onClick={handleBackButton}
                    size="large"
                >
                    <KeyboardBackspaceIcon />
                </IconButton>
            )}
            {!!title && !titleDisable && (
                <Typography data-sta-id={titleID} variant="h1">
                    {title}
                </Typography>
            )}
            {!!handleClose && !closeDisable && (
                <IconButton
                    data-sta-id={closeID}
                    aria-label="close"
                    className={classes.modalCloseButton}
                    onClick={handleClose}
                    size="large"
                >
                    <CloseIcon />
                </IconButton>
            )}
        </div>
    )
}

export default withStyles(themeStyles.useModalStyles)(FixedModalHeader)
